import React, { Component, ReactNode } from 'react';
import './NavigationBlock.scss';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import Badge from 'react-bootstrap/Badge';

interface NavigationBlockProps extends RouteComponentProps<any> {
  title: string;
  subTitle?: string;
  personal?: boolean;
  external?: boolean;
  badge?: number;
  to?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
}

class NavigationBlock extends Component<NavigationBlockProps> {
  handleClick = (): void => {
    if (this.props.to) {
      this.props.history.push(this.props.to);
    }
    if (this.props.href) {
      const tab = window.open(this.props.href, '_blank', 'noreferrer noopener');
      if (tab) {
        tab.focus();
      }
    }
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render(): ReactNode {
    const { title, badge, personal, external, className, subTitle } = this.props;
    const classStyle = `navigation-block--${personal ? 'personal' : external ? 'external' : ''}`;
    const fullClassName = `navigation-block ${classStyle} ${className || ''}`;
    return (
      <button className={fullClassName} onClick={this.handleClick}>
        {
          (!!badge && badge > 0) &&
          <Badge className="navigation-block__badge" pill variant="info">{badge}</Badge>
        }
        { subTitle && <div className="navigation-block__subtitle">{subTitle}</div>}
        <div className="navigation-block__title">{title}</div>
      </button>
    );
  }
}

export default withRouter(NavigationBlock);
